export const faqs = [
  {
    id: "question-1",
    question: "How much does a website cost?",
    answer:
      "Every project is different. Our websites are custom-built to fit your goals, functionality, and long-term needs. Once we learn more about your project during discovery, we’ll provide a detailed proposal and estimate.",
    cta: {
      label: "Learn more about our pricing",
      mobileLabel: "Learn more",
      href: "/about/pricing",
    },
  },
  {
    id: "question-2",
    question: "How long does it take to build a website?",
    answer:
      "Timelines vary depending on the project size, complexity, and how quickly content is provided by you. We’ll give you a clear anticipated timeline with your estimate.",
  },
  {
    id: "question-3",
    question: "What’s the design process like?",
    answer:
      "We start with discovery to understand your goals, audience, and brand. From there, we move into design, development, testing, and launch. Each step includes collaboration and check-ins to keep things on track.",
  },
  {
    id: "question-4",
    question: "How do I make sure my website reflects my brand?",
    answer:
      "We’ll work with your logo or brand colors and other brand collateral as we work to design your new site. We’ll be sure your new site will be a consistent and integral part of your overall brand.",
  },
  {
    id: "question-5",
    question: "How does Airtight Design use AI?",
    answer:
      "In three ways. First, AI is woven into how we deliver every project. It accelerates our design, development, and QA processes so you get better results, faster. Second, we build AI features into client products, like intelligent search, natural-language interfaces, and smart automation. Third, we help dev teams and business owners learn to build and work with AI through hands-on consulting and training. We’ve spent 20 years adopting what’s next. AI is the latest chapter in that pattern.",
  },
  {
    id: "question-6",
    question: "Do you provide content or photography?",
    answer:
      "While we don’t directly provide copywriting or custom photography, we can provide stock photography and/or coordinate with your copywriter or photographer of choice. We also have a network of highly skilled professionals for additional creative work, if needed. Clear, high-quality content makes all the difference, and we’ll guide you through what works best.",
  },
  {
    id: "question-7",
    question: "Can you integrate tools like forms, email marketing, or CRMs?",
    answer:
      "Yes. We frequently connect websites with tools like Mailchimp, HubSpot, Salesforce, and other platforms that help you collect leads or automate tasks. ",
  },
  {
    id: "question-8",
    question: "Can I update the website myself?",
    answer:
      "Yes. We build sites with easy-to-use content management systems so you can make updates to text, images, and pages without needing a developer. We can also provide training once the site launches.",
  },
  {
    id: "question-9",
    question: "Will my website work on phones and tablets?",
    answer:
      "Yes. Every site we build is fully responsive, meaning it automatically adjusts for all screen sizes and devices.",
  },
  {
    id: "question-10",
    question: "Will my site show up on Google?",
    answer:
      "We include SEO best practices during development to help your site perform well in search results, including adapting our processes to account for AI search engine analysis. We can also recommend ongoing SEO strategies for long-term visibility.",
  },
  {
    id: "question-11",
    question: "What if I already have a website?",
    answer:
      "We can audit your current site, identify what’s working, and rebuild or refresh what isn’t. Whether you need a full overhaul or a few upgrades, we’ll recommend the best approach.",
  },
  {
    id: "question-12",
    question: "What about security and backups?",
    answer:
      "Security is built into everything we do. We include SSL certificates, safe login practices, and automated backups so your site stays protected and recoverable.",
  },
  {
    id: "question-13",
    question: "Do you host websites?",
    answer:
      "We can provide secure, high-performance hosting through a third-party vendor or work with your existing provider. Either way, we’ll make sure your site is stable and well-supported.",
  },
  {
    id: "question-14",
    question: "What happens after launch?",
    answer:
      "We’ll make sure everything’s running smoothly, hand over admin access, and provide any needed training. Many of our clients stay with us for ongoing support and enhancements as their needs grow.",
  },
  {
    id: "question-15",
    question: "Do you offer ongoing support or maintenance?",
    answer:
      "Absolutely. We offer maintenance options in both retainer and as-needed models that include backups, updates, security monitoring, and content support. We can tailor a plan to fit your needs.",
  },
];
